import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-custom-tab',
  template: '',
})
export class CustomTabComponent {

  @Input() header!: string;
  @ContentChild('header', { static: false }) headerTemplate!: TemplateRef<any>;
  @ContentChild('content', { static: false }) contentTemplate!: TemplateRef<any>;

}
